import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  summary: string;
  author: string;
  date: string;
  image: string;
  tags: string[];
  views: number;
}

export default function ArticleCard({ id, title, summary, author, date, image, tags, views }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="flex flex-col sm:flex-row">
        <div className="sm:w-48 sm:flex-shrink-0">
          <div className="relative overflow-hidden aspect-video sm:aspect-[4/3] sm:h-full bg-background-200">
            <img
              src={image}
              alt={title}
              title={`${title} - 蘑菇影视`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>
        <div className="p-4 flex flex-col justify-between flex-1">
          <div>
            <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
              {title}
            </h3>
            <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
              {summary}
            </p>
          </div>
          <div className="mt-3 flex items-center justify-between flex-wrap gap-2">
            <div className="flex items-center gap-2 flex-wrap">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700"
                >
                  {tag}
                </span>
              ))}
            </div>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span>{author}</span>
              <span>{date}</span>
              <span className="flex items-center gap-1">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-eye-line text-xs"></i>
                </div>
                {views.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}